class ProductImgScroller extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    this.scroller = this.querySelector(`#product-img-scroller__scroller-${this.sectionId}`);
    this.leftArrow = this.querySelector(`#product-img-scroller__left-arrow-${this.sectionId}`);
    this.rightArrow = this.querySelector(`#product-img-scroller__right-arrow-${this.sectionId}`);

    this.maxScrollLeft = this.scroller.scrollWidth - this.scroller.clientWidth;
    // set default arrow visibility
    if (this.scroller.scrollLeft === 0) {
      this.leftArrow.dataset.visibility = 'hidden';
      this.rightArrow.dataset.visibility = 'show';
    } else if (this.scroller.scrollLeft >= this.maxScrollLeft - 1) {
      this.rightArrow.dataset.visibility = 'hidden';
      this.leftArrow.dataset.visibility = 'show';
    }


    this.handleScroll = this.handleScroll.bind(this);

    this.scroller.addEventListener('scroll', this.handleScroll);
    this.leftArrow.addEventListener('click', this.handleScroll);
    this.rightArrow.addEventListener('click', this.handleScroll);
  }

  disconnectedCallback() {
    this.scroller.removeEventListener('scroll', this.handleScroll);
    this.leftArrow.removeEventListener('click', this.handleScroll);
    this.rightArrow.removeEventListener('click', this.handleScroll);
  }

  handleScroll(e) {
    // scroll the scroller if one of the arrow is clicked
    if (e.type === 'click') {
      const isLeft = e.target === this.leftArrow || this.leftArrow.contains(e.target);
      const isRight = e.target === this.rightArrow || this.rightArrow.contains(e.target);

      if (isLeft) {
        const currentLeft = this.scroller.scrollLeft;
        const targetLeft = Math.max(0, currentLeft - this.scroller.clientWidth);
        this.scroller.scroll({ left: targetLeft, behavior: 'smooth' });
      } else if (isRight) {
        const currentLeft = this.scroller.scrollLeft;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const targetLeft = Math.min(maxScroll, currentLeft + this.scroller.clientWidth);
        this.scroller.scroll({ left: targetLeft, behavior: 'smooth' });
      }
    }

    // hide the arrows based on scroller scrollLeft and maxScrollLeft
    // triggered for mouse scroll or arrow clicks
    if (this.scroller.scrollLeft === 0) {
      this.leftArrow.dataset.visibility = 'hidden';
      this.rightArrow.dataset.visibility = 'show';
    } else if (this.scroller.scrollLeft >= this.maxScrollLeft - 1) {
      this.rightArrow.dataset.visibility = 'hidden';
      this.leftArrow.dataset.visibility = 'show';
    } else {
      this.rightArrow.dataset.visibility = 'show';
      this.leftArrow.dataset.visibility = 'show';
    }
  }
}

customElements.define('product-img-scroller', ProductImgScroller);
